import ActiveAlerts from './ActiveAlerts'

export default ActiveAlerts
